<script lang="ts" setup>
const props = defineProps({
  icon: {
    type: String,
    default: 'icon-arrow-right'
  }
})
</script>

<template>
  <nuxt-link class="link">
    <span class="link__icon"><svg-icon :name="props.icon" /></span>
    <span class="link__text">立即探索</span>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: toRem(83);
  min-height: toRem(73);
  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $color-gray-line;
    border-radius: 50%;
    width: toRem(73);
    height: toRem(73);
    color: $color-brand-3;
    transition: all 0.5s;
    @include min-media(768) {
      position: absolute;
      right: 0;
      top: 0;
    }
    @include max-media(480) {
      width: toRem(52);
      height: toRem(52);
    }
    svg {
      width: toRem(37);
      height: toRem(37);
      @include max-media(480) {
        width: toRem(24);
        height: toRem(24);
      }
    }
  }
  &__text {
    padding-left: toRem(10);
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
    color: $color-gray-1;
    transition: all 0.5s;
    @include min-media(768) {
      opacity: 0;
    }
    @include max-media(480) {
      font-size: toRem(16);
    }
  }
  &:hover {
    @include min-media(768) {
      .link {
        &__icon {
          left: 0;
          right: auto;
        }
        &__text {
          opacity: 1;
        }
      }
    }
  }
}
</style>
